import { makeStyles } from "tss-react/mui"
import { Stack, useTheme } from "@mui/material"
import { useApiQuery } from "../../../../core/api/useApiQuery"
import {
    fetchNotifications,
    FetchNotificationsResponse,
    NotificationQuery,
} from "./notificationApi"
import { useDateTime } from "../../../../modules/localization/useDateTime"
import { faBell as faBellSolid } from "@fortawesome/pro-solid-svg-icons"
import { EmptyContent } from "../../../components/skeleton/EmptyContent"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { NotificationCard } from "./NotificationCard"

const useStyles = makeStyles()(() => ({
    emptyContentContainer: {
        height: "60vh",
    },
    contentContainer: {
        paddingTop: "2rem",
    },
}))

function selectNotifications(response: FetchNotificationsResponse) {
    return response.notifications
}

export function NotificationPane() {
    const { classes } = useStyles()
    const theme = useTheme()
    const dateTimeFactory = useDateTime()

    const { data: notifications, isLoading } = useApiQuery(fetchNotifications, {
        queryName: NotificationQuery.NOTIFICATIONS_LIST,
        dependencies: {},
        select: selectNotifications,
        useErrorBoundary: true,
        staleTime: 0,
    })

    if (isLoading) {
        return (
            <Stack spacing="1rem" className={classes.contentContainer}>
                <NotificationCard notification={undefined} dateTimeFactory={dateTimeFactory} />
                <NotificationCard notification={undefined} dateTimeFactory={dateTimeFactory} />
            </Stack>
        )
    }

    if (notifications) {
        if (notifications.length === 0) {
            return (
                <div className={classes.emptyContentContainer}>
                    <LocalizedStrict
                        id="user-home-top-bar-news-no-notifications"
                        attrs={{ title: true, description: true }}
                    >
                        <EmptyContent
                            icon={faBellSolid}
                            backgroundColor={theme.palette.tailwind.pink[500]}
                            title="No messages right now"
                            description="Here you will be able to read messages from the merchant and service center."
                        />
                    </LocalizedStrict>
                </div>
            )
        } else {
            return (
                <Stack spacing="1rem" className={classes.contentContainer}>
                    {notifications.map((notification) => (
                        <NotificationCard
                            key={notification.id}
                            notification={notification}
                            dateTimeFactory={dateTimeFactory}
                        />
                    ))}
                </Stack>
            )
        }
    }

    throw new Error("Internal error in component")
}
